import React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
} from 'react-share';

interface SocialShareProps {
  url: string;
  title: string;
  description: string;
}

const SocialShare: React.FC<SocialShareProps> = ({ url, title, description }) => {
  const iconSize = 32;
  const round = true;

  const handleShareError = (error: Error, platform: string) => {
    console.warn(`Share error on ${platform}:`, error);
  };

  return (
    <div className="flex items-center gap-3">
      <FacebookShareButton 
        url={url} 
        quote={description}
        onShareWindowClose={() => console.log('Facebook share closed')}
      >
        <FacebookIcon size={iconSize} round={round} />
      </FacebookShareButton>

      <TwitterShareButton 
        url={url} 
        title={title}
        onShareWindowClose={() => console.log('Twitter share closed')}
      >
        <TwitterIcon size={iconSize} round={round} />
      </TwitterShareButton>

      <WhatsappShareButton 
        url={url} 
        title={title}
        onShareWindowClose={() => console.log('WhatsApp share closed')}
      >
        <WhatsappIcon size={iconSize} round={round} />
      </WhatsappShareButton>

      <LinkedinShareButton 
        url={url} 
        title={title} 
        summary={description}
        onShareWindowClose={() => console.log('LinkedIn share closed')}
      >
        <LinkedinIcon size={iconSize} round={round} />
      </LinkedinShareButton>
    </div>
  );
};

export default SocialShare;